import React from "react";
// import PropTypes from "prop-types";
import { TextArea } from "@components/Input";
import styles from "./styles/Question.module.css";
import clsx from "clsx";

const MultipleLineQuestion = (props) => {
  const { userAnswer, onChange, correctAnswer, isCorrect, showAnswer } = props;

  // state

  // variables

  // logics before hooks

  // hooks

  // logics

  // UI partials

  // effects

  // render
  return (
    <div>
      <TextArea
        placeholder={!showAnswer && "Type your answer..."}
        value={userAnswer[0]}
        onChange={(e) => onChange([e.target.value])}
        readonly={showAnswer}
        className={clsx("mb-0", styles.option)}
      />
      {showAnswer && !isCorrect && (
        <p className="mt-2">
          <b>Answer: {correctAnswer}</b>
        </p>
      )}
    </div>
  );
};

/* required: display name */
MultipleLineQuestion.displayName = "MultipleLineQuestion";

/* required: props types */
MultipleLineQuestion.propTypes = {};

/* required: default props */
MultipleLineQuestion.defaultProps = {};

export { MultipleLineQuestion };
